import React from 'react';
import { SearchablePeriscopeV3WorkflowRuleList } from '@periscopes/general/workflow-rules';

export interface EmailAlertWorkflowRulesTabProps {
	index: number;
	sonarObjectId: number;
}

export const EmailAlertWorkflowRulesTab: React.FC<EmailAlertWorkflowRulesTabProps> = ({
	index,
	sonarObjectId
}) => {
	const targetUri = `v3/salesforce/workflow-alerts/${sonarObjectId}/workflow-rules`;

	return <SearchablePeriscopeV3WorkflowRuleList
		parentIndex={ index }
		uri={ targetUri } />;
};
